export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtBankUcet';
export const NAME = 'BankovniUcet';
